import { createSlice } from '@reduxjs/toolkit'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'

const { CUSTOMER_IDS } = customerHelper

const DEFAULT_OPTIONS_BY_CUSTOMER = {
  [CUSTOMER_IDS.TME]: {
    selectedTab: 'explore',
    selectedView: 'Front',
    selectedPart: '',
    searchValue: ''
  },
  [CUSTOMER_IDS.SUBARU]: {
    selectedTab: '',
    selectedView: 'Front',
    selectedPart: '',
    searchValue: ''
  },
  [CUSTOMER_IDS.NORDICS]: {
    selectedTab: '',
    selectedView: 'Front',
    selectedPart: '',
    searchValue: ''
  }
}

const DEFAULT_OPTIONS = { ...DEFAULT_OPTIONS_BY_CUSTOMER[customerId] }

const initialState = {
  options: { ...DEFAULT_OPTIONS },
  searchCache: null
}

const overview = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    UPDATE_OPTIONS: (state, { payload }) => {
      state.options = { ...state.options, ...payload }
    },
    RESET_OPTIONS: state => {
      state.options = { ...DEFAULT_OPTIONS }
    },
    SET_SEARCH_CACHE: (state, { payload }) => {
      state.searchCache = payload
    }
  }
})

export default overview

export const overviewActions = overview.actions

export const overviewSelectors = {
  selectOverview: ({ overview }) => overview,
  selectOptions: ({ overview }) => overview?.options,
  selectSearchCache: ({ overview }) => overview?.searchCache
}
